import { ActionIcon, HomeIcon } from '@tymbe/ui-icons';
import classNames from 'classnames';
import { ApplicationData } from '../../../../types/TymbeApi';
import TymberInfoBox from '../TymberInfoBox';
import TymberAppStateIcon from '../TymberAppStateIcon';
import { notDeleted } from '../utils';
import {
  attendanceRateCalculation
} from '../../../shift/create/components/TySelectInvitations/TySelectInvitationUtils';

interface ParticipantInfoProps {
  applications: ApplicationData[];
  onAppCancel: (appId: number) => void;
}

const ParticipantInfo = ({
  applications,
  onAppCancel,
}: ParticipantInfoProps) => {
  return (
    <div className='divide-y divide-secondary-100'>
      {applications.map((app, index) => {
        const attendanceRate = attendanceRateCalculation(app.person?.personData?.attendanceCount, app.person?.personData?.applicationCount)
        return(
          <div
            key={app.id}
            className="py-0 flex justify-between items-center hover:rounded-lg"
          >
            <TymberInfoBox personId={app.person_id} icon={<TymberAppStateIcon application={app}/>}/>
            <div className="flex text-caption-xl text-secondary-500 items-center gap-1 font-medium">
              <span className="flex gap-0.5 items-center mr-2">
                <HomeIcon
                  name="electric_bolt"
                  className="size-3 text-secondary-400"
                />
                {attendanceRate ? `${Math.ceil(attendanceRate)}%` : '-'}
              </span>
              <span className="flex gap-0.5 items-center mr-2">
                <ActionIcon
                  name="thumb_up"
                  className="size-3 text-secondary-400"
                />
                {app.person?.personData?.job_evaluation ? `${app.person?.personData?.job_evaluation}%` : '-'}
              </span>
              <button
                className={classNames(
                  'rounded-full border border-red-300 size-6 p-0 flex justify-center',
                  'items-center text-red-500 disabled:text-secondary-400 disabled:border-secondary-200'
                )}
                onClick={() => onAppCancel(app.id)}
                disabled={
                  app.state !== null ||
                  notDeleted(app)
                }
              >
                <ActionIcon name="delete_outline" className="size-4 " />
              </button>
            </div>
          </div>
      )})}
    </div>
  );
};

export default ParticipantInfo;
